import React from 'react'
import styles from './styles.module.scss'

export default function Cover() {
  return (
    <div className={styles.cover}>
    </div>
  )
}
